/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { KonturZakupkiIcon16Light } from './KonturZakupkiIcon16Light';
import { KonturZakupkiIcon16Regular } from './KonturZakupkiIcon16Regular';
import { KonturZakupkiIcon16Solid } from './KonturZakupkiIcon16Solid';
import { KonturZakupkiIcon20Light } from './KonturZakupkiIcon20Light';
import { KonturZakupkiIcon20Regular } from './KonturZakupkiIcon20Regular';
import { KonturZakupkiIcon20Solid } from './KonturZakupkiIcon20Solid';
import { KonturZakupkiIcon24Regular } from './KonturZakupkiIcon24Regular';
import { KonturZakupkiIcon24Solid } from './KonturZakupkiIcon24Solid';
import { KonturZakupkiIcon32Regular } from './KonturZakupkiIcon32Regular';
import { KonturZakupkiIcon64Regular } from './KonturZakupkiIcon64Regular';
var sizes = {
    16: {
        light: KonturZakupkiIcon16Light,
        regular: KonturZakupkiIcon16Regular,
        solid: KonturZakupkiIcon16Solid,
    },
    20: {
        light: KonturZakupkiIcon20Light,
        regular: KonturZakupkiIcon20Regular,
        solid: KonturZakupkiIcon20Solid,
    },
    24: {
        regular: KonturZakupkiIcon24Regular,
        solid: KonturZakupkiIcon24Solid,
    },
    32: {
        regular: KonturZakupkiIcon32Regular,
    },
    64: {
        regular: KonturZakupkiIcon64Regular,
    },
};
export var KonturZakupkiIcon = forwardRef('KonturZakupkiIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
